export default __webpack_public_path__ + "static/media/guide-cover-background.affa5c2a.png";